export { RandomForestClassifier } from './RandomForestClassifier';
export { RandomForestRegression } from './RandomForestRegression';



// WEBPACK FOOTER //
// ./node_modules/ml-random-forest/src/index.js